import { ApplicationStatus } from 'enums/ApplicationStatus';
import { DashboardLabelName } from 'enums/DashboardLabelName';
import { setLoanPortal } from 'prequalificationV2/actions/dashboardPortal';
import { BankAccountsStatus } from 'enums/BankAccountsStatus';
import { ApplicationDto } from 'prequalificationV2/api/ApplicationApi';

export const getCurrentLabel = (status?: ApplicationStatus) => {
  switch (status) {
    case ApplicationStatus.Active:
      return DashboardLabelName.NewInquiry;

    case ApplicationStatus.Pitched:
      return DashboardLabelName.Prequalified;

    case ApplicationStatus.Purgatory:
    case ApplicationStatus.Processing:
    case ApplicationStatus.Compliance:
    case ApplicationStatus.ReadyToSubmit:
      return DashboardLabelName.Processing;

    case ApplicationStatus.Underwriting:
    case ApplicationStatus.NeedMoreInfo:
    case ApplicationStatus.NMICompleted:
      return DashboardLabelName.Underwriting;

    case ApplicationStatus.PendingFunding:
      return DashboardLabelName.Approved;

    case ApplicationStatus.Approved:
      return DashboardLabelName.Funded;

    case ApplicationStatus.Rejected:
      return DashboardLabelName.Denied;

    default:
      return '';
  }
};

export const getCompleteInformationDueDateMessage = (dueDate: string | null): string => {
  if (!dueDate) {
    return '';
  }

  return `Submit All Required Information and Documents by ${dueDate}.`;
};

export const updateDashboardLoanPortalInfo = (borrowerApplication: ApplicationDto, dispatch: any) => {
  const variables = borrowerApplication?.variables;

  const borrowerEmploymentInformationComplete = variables.borrower_employment_information_complete as boolean;
  const coBorrowerEmploymentInformationComplete = variables.coborrower_employment_information_complete as boolean;
  const fundingInformationComplete = variables.funding_information_complete as boolean;
  const borrowerPayrollProviderIsDisabled = variables.borrower_payroll_provider_is_disabled as boolean;
  const coBorrowerPayrollProviderIsDisabled = variables.coborrower_payroll_provider_is_disabled as boolean;
  const borrowerInformationRequired = variables.borrower_information_required as boolean;
  const coBorrowerInformationRequired = variables.coborrower_information_required as boolean;
  const fundingInformationIsRequired = variables.funding_information_is_required as boolean;
  const isThereNonBorrowingCoOwner = variables.is_there_a_non_borrowing_coowner as boolean;
  const isHomeOwnershipInformationComplete = variables.homeownership_information_complete as boolean;
  const isCoOwnerInformationComplete = variables.coowner_information_complete as boolean;
  const bankAccountsStatus = variables.bank_accounts_refresh_status as BankAccountsStatus;
  const fundingInformationErrorMessage = variables.giact_validation_error_message;
  const financialAccountAggregationAttemptComplete =
    variables.borrower_financial_account_aggregation_attempt_complete as boolean;
  const autopayDefaultValue = typeof variables.autopay === 'boolean' ? variables.autopay : null;
  const autopaySectionIsRequired = variables.autopay_required as boolean;
  const autopaySectionIsCompleted = autopayDefaultValue !== null;
  const contractorInformationComplete = variables.contractor_information_complete as boolean;

  dispatch(
    setLoanPortal({
      borrowerPayrollProviderIsDisabled: borrowerPayrollProviderIsDisabled,
      coBorrowerPayrollProviderIsDisabled: coBorrowerPayrollProviderIsDisabled,
      borrowerInformationRequired: borrowerInformationRequired,
      coBorrowerInformationRequired: coBorrowerInformationRequired,
      fundingInformationIsRequired: fundingInformationIsRequired,
      fundingInformationComplete: fundingInformationComplete,
      contractorInformationComplete: contractorInformationComplete,
      payrollProviderBorrowerVerificationStates: variables.payroll_provider_borrower_verification_states,
      payrollProviderCoBorrowerVerificationStates: variables.payroll_provider_coborrower_verification_states,
      isThereNonBorrowingCoOwner: isThereNonBorrowingCoOwner,
      isCoOwnerInformationComplete: isCoOwnerInformationComplete,
      isHomeOwnershipInformationComplete: isHomeOwnershipInformationComplete,
      borrowerEmploymentInformationComplete: borrowerEmploymentInformationComplete,
      coBorrowerEmploymentInformationComplete: coBorrowerEmploymentInformationComplete,
      bankAccountsStatus: bankAccountsStatus,
      fundingInformationErrorMessage: fundingInformationErrorMessage,
      financialAccountAggregationAttemptComplete: financialAccountAggregationAttemptComplete,
      autopayDefaultValue: autopayDefaultValue,
      autopaySectionIsRequired: autopaySectionIsRequired,
      autopaySectionIsCompleted: autopaySectionIsCompleted,
    }),
  );
};
